import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShipmentCustomerEntity } from '../../domain/entities/ShipmentCustomerEntity'
import type { ShipmentCustomerInfoAdminDto } from '@/backend/market'

export class ShipmentCustomerModel extends ShipmentCustomerEntity {
  constructor(dataDto: ShipmentCustomerInfoAdminDto) {
    super()
    mapEntityProperties<ShipmentCustomerEntity>(this, dataDto, {
      exclude: []
    })
  }
}
